// src/components/Dashboard/FulfillableOrdersPanel.js
import React from 'react';

const FulfillableOrdersPanel = ({ fulfillableOrders }) => {
	return (
		<div className="p-5 pt-0">
			<div className="overflow-x-auto">
				{fulfillableOrders?.length > 0 ? (
					<table className="min-w-full divide-y divide-gray-200">
						<thead className="bg-gray-50">
						<tr>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Order Number
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Customer
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Status
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Fulfillable Items
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Total Items
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Details
							</th>
						</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
						{fulfillableOrders.map((order, index) => (
							<tr key={index} className="hover:bg-gray-50">
								<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
									{order.order_number}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
									{order.customer_name}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full
                      ${order.status === 'pending' ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800'}`}>
                      {order.status}
                    </span>
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-green-500 font-medium">
									{order.fulfillable_items.length}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
									{order.total_items}
								</td>
								<td className="px-6 py-4 text-sm text-gray-500">
									<div className="max-h-24 overflow-y-auto">
										{order.fulfillable_items.map((item, idx) => (
											<div key={idx} className="mb-2 pb-2 border-b border-gray-100 last:border-0">
												<div className="font-medium">{item.sku} - {item.name}</div>
												<div className="text-xs text-gray-500">Qty: {item.quantity}</div>
												<div className="text-xs flex items-center">
													<span className="inline-block h-1.5 w-1.5 rounded-full bg-green-400 mr-1"></span>
													{item.parts_status}
												</div>
											</div>
										))}
									</div>
								</td>
							</tr>
						))}
						</tbody>
					</table>
				) : (
					 <p className="text-gray-500 py-4">No fulfillable orders data available.</p>
				 )}
			</div>
		</div>
	);
};

export default FulfillableOrdersPanel;
